import { defineFcm } from '../shared/factory';

export const FCM_MOVEMENT_PETITION_ADD_NOTIFICATION = defineFcm('movement_petition_add_notification')
	.asBoolean()
	.withDefault(false)
	.toConfig();
